import { MapPin } from 'lucide-react';
import { motion } from 'motion/react';
import React from 'react';

import { LinkButton } from '../components/LinkButton';

export default function Accommodation() {
  const address = 'Jílové u Děčína, Česká republika';

  const infoItems = [
    { label: 'Check-in (Příchod do safezone)', value: 'Od 15:00' },
    { label: 'Check-out (Opuštění safezone)', value: 'Do 10:00 (Server restart)' },
    { label: 'Frekvence vysílačky', value: '87.8 MHz (Nouzový kanál)' },
    { label: 'Pravidla zóny', value: 'Zbraně v pouzdrech, žádné PVP' },
  ];

  return (
    <>
      {/* Main Responsive Area */}
      <main
        className="overflow-y-none mx-auto flex w-full max-w-4xl flex-1 flex-col gap-6"
        id="main_content"
      >
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
          className="overflow-hidden bg-white pb-10 shadow-sm"
        >
          {/* Hero section with visual of the safezone */}
          <div className="relative h-64 w-full overflow-hidden bg-slate-100 sm:h-80 md:h-96">
            <img
              src="/images/destinations/severograd.webp"
              alt="Safezone Northern Panorama v Jílovém"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-linear-to-t from-black/80 via-black/10 to-transparent" />
            <div className="absolute right-0 bottom-0 left-0 p-6 text-white sm:p-8">
              <h2 className="font-display text-2xl font-bold md:text-3xl">
                Safezone: Northern Panorama
              </h2>
              <p className="mt-1 flex items-center gap-1 text-xs text-slate-200 md:text-sm">
                <MapPin className="h-3.5 w-3.5 text-emerald-400" /> {address}
              </p>
            </div>
          </div>

          {/* Details Content Layout */}
          <div className="p-4 sm:p-8">
            <div className="divide-y divide-slate-100">
              {infoItems.map((item, idx) => (
                <div
                  key={idx}
                  className="flex justify-between py-3 text-sm first:pt-0"
                >
                  <span className="font-medium text-slate-600">{item.label}</span>
                  <span className="font-bold text-slate-900">{item.value}</span>
                </div>
              ))}
              <div className="flex items-center justify-between gap-3 pt-3 text-sm">
                <div>
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/20 bg-emerald-500/10 px-2.5 py-1 text-xs font-semibold text-emerald-700">
                    Chata zajištěna &bull; Teplá voda &bull; Pevné stěny
                  </span>
                </div>
                <div className="flex gap-3">
                  <LinkButton
                    variant="googlemaps"
                    href="https://www.google.com/maps/place/J%C3%ADlov%C3%A9/"
                    type="icon"
                  ></LinkButton>
                  <LinkButton
                    variant="mapycz"
                    href="https://mapy.cz/turisticka?q=J%C3%ADlov%C3%A9&id=10332"
                    type="icon"
                  ></LinkButton>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </main>
    </>
  );
}
